/**
 * 全局配置文件
 * 用于管理不同环境的域名和基础配置
 * 
 * 使用方式：
 * 1. 直接修改下面的baseURL配置
 * 2. 或者在项目根目录创建 .env.development / .env.production / .env.test 文件
 *    设置 VUE_APP_BASE_URL 环境变量（优先级更高）
 */

// 根据环境变量获取当前环境，默认为开发环境
const env = process.env.NODE_ENV || 'development'

// 环境配置映射
const configMap = {
  // 开发环境
  development: {
    // 开发环境使用代理，baseURL设为相对路径 '/api'
    // 这样请求会通过 vue.config.js 中的代理转发到后端服务器，避免CORS跨域问题
    baseURL: 'https://demand.jckj928.cn/api', 
    timeout: 10000,
    // 可以添加其他开发环境配置
  },
  // 测试环境
  test: {
    baseURL: 'https://demand.jckj928.cn/api', // 测试环境API地址
    timeout: 10000,
  },
  // 生产环境
  production: {
    baseURL: 'https://demand.jckj928.cn/api', // 生产环境API地址
    timeout: 10000,
  }
}

// 获取当前环境的配置
let config = configMap[env] || configMap.development

// 如果设置了环境变量 VUE_APP_BASE_URL，则优先使用环境变量
// 这样可以通过 .env 文件或部署时设置环境变量来动态配置
if (process.env.VUE_APP_BASE_URL) {
  config = {
    ...config,
    baseURL: process.env.VUE_APP_BASE_URL
  }
}

// 导出配置
export default {
  ...config,
  env, // 当前环境
  // 可以添加其他全局配置
  appName: '石油设备设计平台',
  version: '1.0.0'
}

// 也可以单独导出常用配置项，方便直接使用
export const BASE_URL = config.baseURL
export const API_TIMEOUT = config.timeout
